/* Ghostworks theme — cart drawer, quantity controls, variant swatches, add-to-cart */
(function () {
  "use strict";

  const drawer = document.querySelector("[data-cart-drawer]");
  const overlay = document.querySelector("[data-cart-drawer-overlay]");
  const openTriggers = document.querySelectorAll("[data-cart-drawer-open]");
  const closeTriggers = document.querySelectorAll("[data-cart-drawer-close]");
  const cartCountEls = document.querySelectorAll("[data-cart-count]");
  const drawerBody = document.querySelector("[data-cart-drawer-body]");
  const drawerFooter = document.querySelector("[data-cart-drawer-footer]");

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    overlay && overlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    overlay && overlay.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  openTriggers.forEach((el) => el.addEventListener("click", (e) => {
    e.preventDefault();
    openDrawer();
    refreshDrawer();
  }));
  closeTriggers.forEach((el) => el.addEventListener("click", closeDrawer));
  overlay && overlay.addEventListener("click", closeDrawer);

  function money(cents, currency) {
    return (cents / 100).toLocaleString(undefined, { style: "currency", currency: currency || "USD" });
  }

  function renderDrawer(cart) {
    if (!drawerBody) return;
    cartCountEls.forEach((el) => (el.textContent = cart.item_count));

    if (cart.item_count === 0) {
      drawerBody.innerHTML = '<p style="text-align:center;padding:60px 0;color:var(--text-muted)">Your cart is empty.</p>';
      if (drawerFooter) drawerFooter.style.display = "none";
      return;
    }
    if (drawerFooter) drawerFooter.style.display = "block";

    drawerBody.innerHTML = cart.items
      .map(
        (item) => `
      <div class="cart-line__product" style="margin-bottom:20px;">
        <img src="${item.image || ""}" alt="${item.product_title}">
        <div style="flex:1">
          <div class="cart-line__title">${item.product_title}</div>
          ${item.variant_title ? `<div class="cart-line__variant">${item.variant_title}</div>` : ""}
          <div style="font-family:var(--mono);color:var(--accent-2);margin-top:6px;font-size:0.85rem;">
            ${item.quantity} × ${money(item.price)}
          </div>
        </div>
      </div>`
      )
      .join("");

    const totalEl = drawer.querySelector("[data-cart-drawer-total]");
    if (totalEl) totalEl.textContent = money(cart.total_price);
  }

  function refreshDrawer() {
    fetch("/cart.js")
      .then((r) => r.json())
      .then(renderDrawer)
      .catch(() => {});
  }

  document.querySelectorAll("[data-product-form]").forEach((form) => {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      const submitBtn = form.querySelector("[type=submit]");
      const originalText = submitBtn ? submitBtn.textContent : "";
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = "Adding…";
      }

      const formData = new FormData(form);

      fetch("/cart/add.js", { method: "POST", body: formData })
        .then((r) => r.json())
        .then(() => {
          refreshDrawer();
          openDrawer();
        })
        .catch(() => {
          if (submitBtn) submitBtn.textContent = "Something went wrong";
        })
        .finally(() => {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }
        });
    });
  });

  document.querySelectorAll("[data-qty-selector]").forEach((wrap) => {
    const input = wrap.querySelector("input");
    wrap.querySelectorAll("[data-qty-decrease]").forEach((btn) =>
      btn.addEventListener("click", () => {
        input.value = Math.max(1, parseInt(input.value || "1", 10) - 1);
        input.dispatchEvent(new Event("change"));
      })
    );
    wrap.querySelectorAll("[data-qty-increase]").forEach((btn) =>
      btn.addEventListener("click", () => {
        input.value = parseInt(input.value || "1", 10) + 1;
        input.dispatchEvent(new Event("change"));
      })
    );
  });

  document.querySelectorAll("[data-cart-line-qty]").forEach((input) => {
    input.addEventListener("change", function () {
      const key = input.dataset.cartLineQty;
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: parseInt(input.value, 10) || 0 }),
      }).then(() => window.location.reload());
    });
  });

  document.querySelectorAll("[data-cart-line-remove]").forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      const key = btn.dataset.cartLineRemove;
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: 0 }),
      }).then(() => window.location.reload());
    });
  });

  document.querySelectorAll("[data-variant-swatches]").forEach((group) => {
    group.querySelectorAll(".swatch").forEach((btn) => {
      btn.addEventListener("click", function () {
        if (btn.hasAttribute("disabled")) return;
        group.querySelectorAll(".swatch").forEach((s) => s.classList.remove("is-selected"));
        btn.classList.add("is-selected");
        const hiddenInput = group.parentElement.querySelector("[data-selected-variant-id]");
        if (hiddenInput && btn.dataset.variantId) {
          hiddenInput.value = btn.dataset.variantId;
        }
      });
    });
  });

  const navToggle = document.querySelector("[data-mobile-nav-toggle]");
  const mobileNav = document.querySelector("[data-mobile-nav]");
  if (navToggle && mobileNav) {
    navToggle.addEventListener("click", () => {
      mobileNav.classList.toggle("is-open");
    });
  }

  document.querySelectorAll("[data-gallery-thumb]").forEach((thumb) => {
    thumb.addEventListener("click", () => {
      const main = document.querySelector("[data-gallery-main]");
      if (main && thumb.dataset.fullSrc) {
        main.src = thumb.dataset.fullSrc;
      }
    });
  });
})();
